import { render, staticRenderFns } from "./SwitchedContainer.vue?vue&type=template&id=399d1994&scoped=true&"
import script from "./SwitchedContainer.vue?vue&type=script&lang=ts&"
export * from "./SwitchedContainer.vue?vue&type=script&lang=ts&"
import style0 from "./SwitchedContainer.vue?vue&type=style&index=0&id=399d1994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399d1994",
  null
  
)

export default component.exports